import Layout from "@/layout";
export default {
    meta: {
        title: "人员",
        icon: "ali_rygl",
    },
    path: "/manager",
    component: Layout,
    children: [
        // {
        //     path: '/manager/company',
        //     name: 'managerCompany',
        //     component: () => import('@/views/manager/company'),
        //     meta: {
        //         title: '用户审核',
        //         auth: [],
        //         img: "yhgl"
        //     }
        // },
        {
            path: "/manager/role",
            name: "role",
            component: () => import("@/views/manager/role/index"),
            meta: {
                title: "角色管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/manager/depart",
            name: "managerDepart",
            component: () => import("@/views/manager/depart"),
            meta: {
                title: "部门",
                auth: [],
                img: "bm",
            },
        },
        {
            path: "/manager/menu",
            name: "menu",
            component: () => import("@/views/manager/menu/index"),
            meta: {
                title: "菜单管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/manager/tenant",
            name: "tenant",
            component: () => import("@/views/manager/tenant/index"),
            meta: {
                title: "租户管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/manager/companyManage",
            name: "companyManage",
            component: () => import("@/views/manager/company/index"),
            meta: {
                title: "公司管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/manager/tenantRole",
            name: "tenantRole",
            component: () => import("@/views/manager/tenantRole/index"),
            meta: {
                title: "角色管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/manager/users",
            name: "users",
            component: () => import("@/views/manager/users/index"),
            meta: {
                title: "用户管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/manager/sysRole",
            name: "users",
            component: () => import("@/views/manager/sysRole/index"),
            meta: {
                title: "默认菜单管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/manager/expert",
            name: "managerExpert",
            component: () => import("@/views/manager/expert/index"),
            meta: {
                title: "专家管理",
                auth: [],
                img: "zz",
            },
        },
        // {
        //     path: '/expert/expert',
        //     name: 'expert',
        //     component: () => import('@/views/expert/expert.vue'),
        //     meta: {
        //         title: '专家库',
        //         auth: [],
        //         img: "zz"
        //     }
        // },
        {
            path: "/manager/project",
            name: "managerProject",
            component: () => import("@/views/manager/project/index"),
            meta: {
                title: "工程管理",
                auth: [],
                img: "jsqx",
            },
        },
        {
            path: "/serviceCenter/index",
            name: "serviceCenter",
            component: () => import("@/views/serviceCenter/index"),
            meta: {
                title: "服务中心管理",
                auth: [],
                img: "jsqx",
            },
        },
    ],
};
